import vars from '../helpers';
import scrollLock from 'scroll-lock';

let $arrowUp = $('.home__arrow');
let $homeCard = $('.home__card');
let $cardButton = $('.card__button');
let $card = $('.card');

let $popupWrap = $('.popup-wrap');
let $popupText = $('.popup__text');
let $popupButton = $('.popup__button, .popup__close, .popup-overlay');
let numClick = 1;
let numClickRate = [];

let newDate = new Date();
let date = newDate.getDate();
let month = newDate.getMonth();

function localStorageGet() {
	if (localStorage.getItem('kpVotingResult') && localStorage.getItem('kpVotingDate') === date.toString() && localStorage.getItem('kpVotingMonth') === month.toString()) {
		let $localStorage = localStorage.getItem('kpVotingResult').split('');

		$(`.card[data-num="${$localStorage[0]}"`).addClass('is-change');
		$(`.card[data-num="${$localStorage[1]}"`).addClass('is-change');
		$(`.card[data-num="${$localStorage[2]}"`).addClass('is-change');

		$('.card:not(.is-change)').find('.card__button').fadeOut(150, () => {
			$('.card.is-change').find('.card__button').removeClass('is-change').addClass('is-done').text('Ваш выбор');
			$card.find('.card__rate').fadeIn(150);
		});

		$card.removeAttr('data-aos');

		$card.each((i, cards) => {
			let $cardDataRate = $(cards).data('rate');

			$(cards).css('order', $cardDataRate);
		});

		$homeCard.addClass('is-opacity');
		setTimeout(() => {
			$homeCard.addClass('is-order').removeClass('is-opacity');
		}, 300);
	}
};

localStorageGet();

function appendRate() {
	$card.each((i, card) => {
		$(card).find('.card__rate-num').text($(card).data('rate'))
	});
};

appendRate();

function openPopup(current) {
	scrollLock.disablePageScroll();
	current.addClass('is-change');
	current.closest('.card').addClass('is-change');
	$popupWrap.fadeIn(300);

	setTimeout(() => {
		current.text('Мой выбор');
	}, 150);
}

$arrowUp.on('click', () => {
	vars.$html.animate({scrollTop: 0}, 300);
})

$cardButton.on('click', (e) => {
	let $current = $(e.currentTarget);
	let $dataNum = $current.closest('.card').data('num');

	$.ajax({
		url: `${location.href}ajax/`,
		type: 'GET',
		dataType: 'json',
		data: {id: $dataNum},
		success: function(data){
			let dataPrecent = data.stats[$dataNum - 1].percent;
	
			$(`.card[data-num="${$dataNum}"]`).attr('data-rate', dataPrecent).find('.card__rate-num').text(dataPrecent); 
		}
	});

	numClickRate.push($dataNum);

	if (numClick === 3) {
		$current.closest('.card').addClass('is-change');
		$current.addClass('is-change');

		$('.card:not(.is-change)').find('.card__button').fadeOut(150, () => {
			$('.card.is-change').find('.card__button').removeClass('is-change').addClass('is-done').text('Ваш выбор');
			$card.find('.card__rate').fadeIn(150);
		});

		$card.removeAttr('data-aos');

		$card.each((i, cards) => {
			let $cardDataRate = $(cards).data('rate');

			$(cards).css('order', $cardDataRate);

		});

		$homeCard.addClass('is-opacity');
		setTimeout(() => {
			let $homeCardScrolTop = $homeCard.offset().top - 60;

			$homeCard.addClass('is-order').removeClass('is-opacity');
			vars.$html.scrollTop($homeCardScrolTop);
		}, 300);

		localStorage.setItem('kpVotingResult', numClickRate.join(''));
		localStorage.setItem('kpVotingDate', date);
		localStorage.setItem('kpVotingMonth', month);
	}

	if (numClick === 2) {
		openPopup($current);
		$popupText.text('Спасибо за ваш голос. Выберите еще один пункт!')

		numClick = 3;

	}

	if (numClick === 1) {
		openPopup($current);

		numClick = 2;
	}
})

$popupButton.on('click', () => {
	scrollLock.enablePageScroll();
	$popupWrap.fadeOut(300);
});